module.exports = __webpack_public_path__ + "img/athletics_icon_10.dc35799f.png";